import * as React from "react";
import { useApiService } from "../../../../../hooks";
import { DogDnaApi, EIsagNorm } from "../../../../../api";
import { useApiEffect } from "nsitools-react";
import { DogDnaPage } from "./DogDnaPage";
import { DogDnaMarkersList } from "./DogDnaMarkersList";
import { useQuery } from "react-query";

export interface IDogDnaItemPageProps {
  dogId: number;
  editMode: boolean;
  isag: EIsagNorm;
}

export const DogDnaItemPage: React.FunctionComponent<IDogDnaItemPageProps> = ({ dogId, editMode, isag }) => {
  const api = useApiService(DogDnaApi);
  const {
    data: item,
    isFetching: loadingItem,
    refetch,
  } = useQuery(
    ["get-dna-result", dogId, isag],
    React.useCallback(async () => await api.getDnaResult(dogId, isag), [dogId])
  );

  const [dogDnaResultId, setdogDnaResultId] = React.useState<number>();

  React.useEffect(() => {
    setdogDnaResultId(item?.dogDnaResultId);
  }, [item]);

  return (
    item && (
      <>
        {item.dogDnaResultId === 0 ? (
          <DogDnaPage
            dogId={dogId}
            editMode={editMode}
            onSave={(id) => setdogDnaResultId(id)}
            refetchEditMode={refetch}
            isag={isag}
          />
        ) : (
          <DogDnaPage dogId={dogId} editMode={false} refetchEditMode={refetch} isag={isag} />
        )}
        <DogDnaMarkersList dogId={dogId} dogMarkerId={dogDnaResultId} isag={isag} />
      </>
    )
  );
};
